module.exports = __webpack_public_path__ + "static/img/bim11.584ccba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouye/bim11.png
// module id = ZIHG
// module chunks = 17